<p-toast position="top-right"></p-toast>
<p-confirmDialog #cdrsl [style]="{width: '600px'}" key="rsl-dialog">
  <p-footer>
    <button type="button" pButton accesskey="d" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Yes" (click)="cdrsl.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cdrsl.reject()"></button>
  </p-footer>
</p-confirmDialog>

<div>
  <button pButton pRipple 
    label="Create Roster Project" 
    class="p-button-primary p-ml-3" 
    icon="fas fa-align-justify" 
    [disabled]="maxRosterProjectsReached"
    (click)="addOrUpdateRosterProject(null)"></button>
  <button pButton pRipple label="Collapse All" class="p-button-primary p-ml-3" icon="fas fa-angle-double-up" [disabled]="collapseAll" (click)="collapseAll = true;"></button>
  <button pButton pRipple label="Expand All" class="p-button-primary p-ml-3" icon="fas fa-angle-double-down" [disabled]="!collapseAll" (click)="collapseAll = false;"></button>
</div>

<div class="p-m-3 p-error" *ngIf="maxRosterProjectsReached">
  You have reached the maximum number of allowed roster projects (Max allowed roster project: {{maxNumberOfRosterProject}}). 
  For further assistance, please contact Zoesen LLC at sales&#64;zoesen.com.  
</div>

<div class="p-m-3 roster-project" *ngFor="let rp of rosterProjects; let i=index">
  <p-fieldset legend="{{rp.title}} - {{rp.active ? 'Active' : 'Inactive'}}" 
    [styleClass]="rp.active ? 'active' : 'inactive'"
    [collapsed]="collapseAll"
    [toggleable]="true">

    <div class="p-mb-2" *ngIf="canSetPermission()">
      <strong class="p-mr-2">Roles with permission:</strong>
      <strong *ngIf="rp.roleIds.length === 0" class="p-mr-2">Not Set</strong>      
      <ng-container *ngFor="let roleId of rp.roleIds">
        <ng-container *ngIf="rolesDict.hasOwnProperty(roleId)">
          <p-chip [label]="rolesDict[roleId].roleName" icon="pi pi-users" styleClass="p-mr-2 p-mb-2 custom-chip"></p-chip>
        </ng-container>
      </ng-container >
    </div>

    <p-table [value]="rp.groupIds" 
              styleClass="p-datatable-gridlines"
              [tableStyle]="{width: 'auto'}">
      <ng-template pTemplate="header">
        <tr>
          <th class="bg-light-yellow" style="width:400px">
            <span *ngIf="rp.groupIds.length > 0">Employees in these work groups will be counted</span>
            <span *ngIf="rp.groupIds.length === 0">Click Edit button to add work groups</span>
          </th>
          <th class="bg-light-yellow" style="width:50px"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-groupId>
        <tr>
          <td style="width:400px"><i class="fas fa-user-friends fa-lg"></i> <span class="p-ml-3">{{workGroupsDict[groupId].name}}</span></td>
          <td style="width:50px" class="text-center">
            <button pButton pRipple type="button" icon="fas fa-trash-alt fa-lg" class="p-button-rounded p-button-danger p-button-text" 
                    pTooltip="Detach {{workGroupsDict[groupId].name}}"
                    (click)="deleteGroup(i, rp.id, groupId)"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <div class="text-left p-mt-2">
      <button pButton pRipple label="Edit" class="p-button p-mr-2" icon="pi pi-pencil"
              (click)="addOrUpdateRosterProject(rp)"></button>
      <button pButton pRipple label="Delete" class="p-button-danger" icon="pi pi-times" 
              [title]="'Delete roster project'"
              (click)="deleteRosterProject(rp)"></button>
    </div>
  </p-fieldset>
</div>

